export default "__VITE_ASSET__Cql7yxjU__"